import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/common/Elements/Elements';

import classes from './ResultAlert.module.scss';

const ResultAlert = ({ data, isNotFiltered }) => {
  const { count, name, kind = 'success', mode, succeeded, failed } = data;
  const { t } = useTranslation(['activity']);

  return (
    <div className={classes.result}>
      {kind === 'success' ? (
        <Text>
          The
          <Text
            className={cn(classes.platform, classes.blue)}
          >{` ${name} `}</Text>
          feature has been successfully {data.mode} to
          <Text className={classes.blue}>
            {` ${
              count === 0
                ? `All${isNotFiltered ? '' : ' filtered'} Tenants.`
                : count
            } `}
          </Text>
          {count > 0 && t('activity:customers.customers')}
          {typeof succeeded === 'number' && typeof failed === 'number' && (
            <Text>{` (${succeeded} succeeded, ${failed} failed)`}</Text>
          )}
        </Text>
      ) : (
        <Text>
          The
          <Text
            className={cn(classes.platform, classes.red)}
          >{` ${name} `}</Text>
          feature hasn&apos;t been {mode}
        </Text>
      )}
    </div>
  );
};

ResultAlert.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number,
    name: PropTypes.string,
    kind: PropTypes.string,
    mode: PropTypes.string,
    succeeded: PropTypes.number,
    failed: PropTypes.number
  }),
  isNotFiltered: PropTypes.bool
};

export default ResultAlert;
